export const ROUTE_PATH = '/loyalty-history';

export const FEATURE_NAME = 'loyaltyHistoryPage';
